class ProductVideoOpener extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.onClick.bind(this));
  }

  onClick() {
    const modal = document.querySelector(this.getAttribute('data-modal'));
    if (!modal) return;

    const iframe = modal.querySelector('iframe[data-src]');
    if (iframe && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.dataset.src);
    }

    modal.show?.(this.button);
  }
}

customElements.define('product-video-opener', ProductVideoOpener);
